import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Router } from '../../../src/i18n';
import { TP } from '../../../constants/consts';
import { EDITING_PRODUCTION_ENTITY_TYPES } from '../constants';
import StepperButtonsBlock from '../../../components/Stepper/StepperButtonsBlock';
import LivestreamEvents from '../components/DatesStep/LivestreamEvents';
import VideoOnDemand from '../components/DatesStep/VideoOnDemand';
import { getQueryFuncForEditStep } from '../utils';

const useStyles = makeStyles(() => ({
  section: {
    marginBottom: 60,
  },
}));

const EditLivestreamStep = ({ entity, production, step, type }) => {
  const classes = useStyles();
  const queryStepFunc = getQueryFuncForEditStep(type);
  const backStepAction = () => {
    const { pathname, query } = queryStepFunc({ entity, production, step: step - 1 });
    Router.push({ pathname, query });
  };

  const nextStepAction = () => {
    const { pathname, query } = queryStepFunc({ entity, production, step: step + 1 });
    Router.push({ pathname, query });
  };

  return (
    <>
      <LivestreamEvents className={classes.section} />
      <VideoOnDemand className={classes.section} />
      <StepperButtonsBlock
        activeStepNumber={2}
        activeStep={{ backStepAction, nextStepAction, info: null }}
        nextStepText={`${TP}.m_NEXTSTEP`}
      />
    </>
  );
};

EditLivestreamStep.propTypes = {
  entity: PropTypes.object.isRequired,
  production: PropTypes.object,
  step: PropTypes.number,
  type: PropTypes.oneOf(Object.values(EDITING_PRODUCTION_ENTITY_TYPES)).isRequired,
};

export default EditLivestreamStep;
